import HeaderDark from './components/HeaderDark.vue';
import HeaderLight from './components/HeaderLight.vue';
import Intro from './components/Intro.vue';
import ClientLogos from './components/ClientLogos.vue';
import Portfolio from './components/Portfolio.vue';
import PortfolioDetail from './components/PortfolioDetail.vue';
import Experience from './components/Experience.vue';
import Contact from './components/Contact.vue';
import Resume from './components/Resume.vue';

export const routes = [

  // {
  // // you can also redirect with an object `redirect: { name: 'home'}`
  // // path: '/', redirect: '/resume'
  // // or you can use a named route in an object
  // path: '/re', redirect: { name: 'resume' }
  // },

  {
    path: '/resume',
    // alias: ['/'],
    name: 'resume',
    components: {
      'headerLight': HeaderLight,
      'resume': Resume,
    }
  },


  {
    path: '/',
    components: {
      // default: Intro,
      'intro': Intro,
      'clientLogos': ClientLogos,
      'headerDark': HeaderDark
    }
  },

  {
    path: '/portfolio',
    // name is for router linked, as a named route
    name: 'portfolio',
    // components (plural) has key value pair with name: component
    // the name 'headerDark' will be the router-view name=""
    // this is different from the name above that is used for router-links
    components: {
      'headerDark': HeaderDark,
      'portfolio': Portfolio
    },
    children: [
      {
        path: ':client',
        name: 'portfolio-detail',
        components: {
          'portfolioDetail': PortfolioDetail
        }
      }
    ]
  },

  {
    path: '/experience',
    // redirect: { name: 'resume' },
    name: 'experience',
    components: {
      'headerLight': HeaderLight,
      // default: Resume
      'experience': Experience,
    }
  },

  {
    path: '/contact',
    name: 'contact',
    components: {
      'headerDark': HeaderDark,
      default: Contact
    }
  },

  // {
    // path: '/*', redirect: { name: 'resume' }
    // path: '/*', redirect: "/"
  // },


];



// WEBPACK FOOTER //
// ./src/routes.js